import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import Placeholder from '../../components/Placeholder';
import Video from '../../components/BrightcoveVideo';
import { SCREEN_LOCKUP_WIDTH, MOBILE_PADDING } from '../../styles/variables.style';

const Wrapper = styled.section`
  margin: 50px auto;
  max-width: ${SCREEN_LOCKUP_WIDTH + MOBILE_PADDING * 2}px;
  padding: 0 ${MOBILE_PADDING}px;
`;

const VideoSection = ({ video }) => (
  <Wrapper>{video ? <Video {...video} /> : <Placeholder w="100%" pb="calc(100% * 9 / 16)" />}</Wrapper>
);

VideoSection.defaultProps = {
  video: undefined,
};

VideoSection.propTypes = {
  video: PropTypes.shape(),
};

export default VideoSection;



// WEBPACK FOOTER //
// ./src/pages/AboutPage/VideoSection.js